import React, { useEffect, useState, useRef } from 'react';
import api from '../api';

function Badge({ color, children }) {
  const C = { green:{bg:'rgba(74,222,128,.15)',c:'#4ade80'}, red:{bg:'rgba(239,68,68,.15)',c:'#ef4444'}, blue:{bg:'rgba(96,165,250,.15)',c:'#60a5fa'}, yellow:{bg:'rgba(250,204,21,.15)',c:'#facc15'}, gray:{bg:'rgba(100,116,139,.15)',c:'#64748b'}, teal:{bg:'rgba(0,180,180,.15)',c:'var(--accent)'} };
  const s = C[color]||C.gray;
  return <span style={{background:s.bg,color:s.c,fontSize:11,fontWeight:700,padding:'2px 8px',borderRadius:20}}>{children}</span>;
}

function Toast({ msg }) {
  if (!msg) return null;
  const ok = !msg.startsWith('❌');
  return <div style={{position:'fixed',top:20,right:20,zIndex:9999,background:ok?'#f0fdf4':'#fef2f2',color:ok?'#166534':'#dc2626',border:`1px solid ${ok?'#bbf7d0':'#fca5a5'}`,borderRadius:8,padding:'10px 18px',fontSize:13,fontWeight:600,boxShadow:'0 4px 12px rgba(0,0,0,.15)'}}>{msg}</div>;
}

function timeAgo(ts) {
  if (!ts) return '—';
  const diff = Date.now() - new Date(ts);
  if (diff < 60000) return 'şimdi';
  if (diff < 3600000) return Math.floor(diff/60000)+'dk';
  if (diff < 86400000) return Math.floor(diff/3600000)+'sa';
  return new Date(ts).toLocaleDateString('tr-TR');
}

export default function MailSender() {
  const [tab, setTab] = useState('campaigns');
  const [toast, setToast] = useState('');
  const [campaigns, setCampaigns] = useState([]);
  const [lists, setLists] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);

  // Modaller
  const [showCampForm, setShowCampForm] = useState(false);
  const [showListForm, setShowListForm] = useState(false);
  const [showTemplateForm, setShowTemplateForm] = useState(false);
  const [showContacts, setShowContacts] = useState(null);
  const [showLogs, setShowLogs] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const [editTemplate, setEditTemplate] = useState(null);

  // Form state
  const [campForm, setCampForm] = useState({name:'',template_id:'',list_id:'',subject:''});
  const [listForm, setListForm] = useState({name:'',description:''});
  const [tplForm, setTplForm] = useState({name:'',subject:'',body_html:'',body_text:''});
  const [testEmail, setTestEmail] = useState('');

  // Contacts
  const [contacts, setContacts] = useState([]);
  const [contactTotal, setContactTotal] = useState(0);
  const [newContact, setNewContact] = useState({email:'',name:''});
  const [logs, setLogs] = useState([]);
  const [logStats, setLogStats] = useState([]);

  const fileInputRef = useRef();
  const pollRef = useRef();

  useEffect(() => {
    loadCampaigns(); loadLists(); loadTemplates(); loadSettings();
    return () => clearInterval(pollRef.current);
  }, []);

  function msg(m) { setToast(m); setTimeout(() => setToast(''), 4000); }

  async function loadCampaigns() {
    try { const r = await api.get('/mail/campaigns'); setCampaigns(r.data); } catch(e) {}
  }
  async function loadLists() {
    try { const r = await api.get('/mail/lists'); setLists(r.data); } catch(e) {}
  }
  async function loadTemplates() {
    try { const r = await api.get('/mail/templates'); setTemplates(r.data); } catch(e) {}
  }
  async function loadSettings() {
    try { const r = await api.get('/mail/settings'); setSettings(r.data); } catch(e) {}
  }
  async function loadContacts(listId) {
    try { const r = await api.get(`/mail/lists/${listId}/contacts`); setContacts(r.data.contacts); setContactTotal(r.data.total); } catch(e) {}
  }
  async function loadLogs(campId) {
    try { const r = await api.get(`/mail/campaigns/${campId}/logs`); setLogs(r.data.logs); setLogStats(r.data.stats); } catch(e) {}
  }

  async function createCampaign(e) {
    e.preventDefault(); setLoading(true);
    try {
      await api.post('/mail/campaigns', campForm);
      msg('✅ Kampanya oluşturuldu');
      setShowCampForm(false); setCampForm({name:'',template_id:'',list_id:'',subject:''});
      loadCampaigns();
    } catch(ex) { msg('❌ ' + (ex.response?.data?.error || ex.message)); }
    setLoading(false);
  }

  async function sendCampaign(c) {
    if (!window.confirm(`"${c.name}" kampanyası ${c.total_count} kişiye gönderilsin mi?`)) return;
    try {
      await api.post(`/mail/campaigns/${c.id}/send`);
      msg('✅ Gönderim başlatıldı');
      loadCampaigns();
      // Poll status
      pollRef.current = setInterval(async () => {
        const r = await api.get(`/mail/campaigns/${c.id}/status`);
        setCampaigns(prev => prev.map(x => x.id === c.id ? { ...x, ...r.data } : x));
        if (r.data.status === 'sent' || r.data.status === 'failed') clearInterval(pollRef.current);
      }, 3000);
    } catch(ex) { msg('❌ ' + (ex.response?.data?.error || ex.message)); }
  }

  async function deleteCampaign(c) {
    if (!window.confirm(`"${c.name}" silinsin mi?`)) return;
    try { await api.delete(`/mail/campaigns/${c.id}`); loadCampaigns(); }
    catch(ex) { msg('❌ Hata'); }
  }

  async function createList(e) {
    e.preventDefault();
    try { await api.post('/mail/lists', listForm); msg('✅ Liste oluşturuldu'); setShowListForm(false); setListForm({name:'',description:''}); loadLists(); }
    catch(ex) { msg('❌ ' + (ex.response?.data?.error || ex.message)); }
  }

  async function deleteList(l) {
    if (!window.confirm(`"${l.name}" silinsin mi?`)) return;
    try { await api.delete(`/mail/lists/${l.id}`); loadLists(); }
    catch(ex) { msg('❌ Hata'); }
  }

  async function addContact(e) {
    e.preventDefault();
    try {
      await api.post(`/mail/lists/${showContacts.id}/contacts`, newContact);
      msg('✅ Kontak eklendi'); setNewContact({email:'',name:''});
      loadContacts(showContacts.id); loadLists();
    } catch(ex) { msg('❌ ' + (ex.response?.data?.error || ex.message)); }
  }

  async function deleteContact(listId, cid) {
    try { await api.delete(`/mail/lists/${listId}/contacts/${cid}`); loadContacts(listId); loadLists(); }
    catch(ex) { msg('❌ Hata'); }
  }

  async function importCSV(e) {
    const file = e.target.files[0]; if (!file) return;
    const fd = new FormData(); fd.append('file', file);
    try {
      const r = await api.post(`/mail/lists/${showContacts.id}/import`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      msg(`✅ ${r.data.imported} kontak eklendi, ${r.data.skipped} atlandı`);
      loadContacts(showContacts.id); loadLists();
    } catch(ex) { msg('❌ ' + (ex.response?.data?.error || ex.message)); }
    e.target.value = '';
  }

  async function saveTemplate(e) {
    e.preventDefault(); setLoading(true);
    try {
      if (editTemplate) {
        await api.put(`/mail/templates/${editTemplate.id}`, tplForm);
        msg('✅ Şablon güncellendi');
      } else {
        await api.post('/mail/templates', tplForm);
        msg('✅ Şablon oluşturuldu');
      }
      setShowTemplateForm(false); setEditTemplate(null); setTplForm({name:'',subject:'',body_html:'',body_text:''});
      loadTemplates();
    } catch(ex) { msg('❌ ' + (ex.response?.data?.error || ex.message)); }
    setLoading(false);
  }

  async function deleteTemplate(t) {
    if (!window.confirm(`"${t.name}" silinsin mi?`)) return;
    try { await api.delete(`/mail/templates/${t.id}`); loadTemplates(); }
    catch(ex) { msg('❌ Hata'); }
  }

  async function openEditTemplate(t) {
    const r = await api.get(`/mail/templates/${t.id}`);
    setTplForm({ name: r.data.name, subject: r.data.subject, body_html: r.data.body_html, body_text: r.data.body_text || '' });
    setEditTemplate(r.data);
    setShowTemplateForm(true);
  }

  async function saveSettings(e) {
    e.preventDefault();
    try { await api.put('/mail/settings', settings); msg('✅ Ayarlar kaydedildi'); setShowSettings(false); }
    catch(ex) { msg('❌ ' + (ex.response?.data?.error || ex.message)); }
  }

  async function testSMTP() {
    if (!testEmail) return msg('❌ Test email girin');
    setLoading(true);
    try { const r = await api.post('/mail/settings/test', { test_email: testEmail }); msg('✅ ' + r.data.message); }
    catch(ex) { msg('❌ SMTP Hatası: ' + (ex.response?.data?.error || ex.message)); }
    setLoading(false);
  }

  const statusColor = { draft:'gray', sending:'yellow', sent:'green', failed:'red' };
  const statusLabel = { draft:'Taslak', sending:'Gönderiliyor...', sent:'Gönderildi', failed:'Başarısız' };
  const inp = { className:'input', style:{ fontSize:13 } };

  return (
    <div className="page-enter">
      <Toast msg={toast}/>

      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20,flexWrap:'wrap',gap:10}}>
        <div>
          <h1 style={{fontSize:22,fontWeight:800,fontFamily:'Plus Jakarta Sans',marginBottom:4}}>📧 Mail Gönderici</h1>
          <p style={{color:'var(--text3)',fontSize:13}}>Alibaba Direct Mail ile toplu mail kampanyası</p>
        </div>
        <div style={{display:'flex',gap:8}}>
          <button className="btn btn-ghost btn-sm" onClick={()=>setShowSettings(true)}>⚙️ SMTP Ayarları</button>
          <button className="btn btn-primary btn-sm" onClick={()=>setShowCampForm(true)}>+ Kampanya</button>
        </div>
      </div>

      {/* Sekmeler */}
      <div style={{display:'flex',gap:0,borderBottom:'1px solid var(--border3)',marginBottom:20}}>
        {[['campaigns','📨 Kampanyalar'],['lists','📋 Listeler'],['templates','📝 Şablonlar']].map(([v,l])=>(
          <button key={v} onClick={()=>setTab(v)} style={{padding:'10px 18px',background:'none',border:'none',cursor:'pointer',fontSize:13,fontWeight:600,color:tab===v?'var(--accent)':'var(--text3)',borderBottom:tab===v?'2px solid var(--accent)':'2px solid transparent'}}>
            {l} {v==='campaigns'&&campaigns.length?`(${campaigns.length})`:''}{v==='lists'&&lists.length?`(${lists.length})`:''}{v==='templates'&&templates.length?`(${templates.length})`:''}
          </button>
        ))}
      </div>

      {/* ── KAMPANYALAR ── */}
      {tab==='campaigns'&&(
        <div>
          {!campaigns.length&&<div style={{textAlign:'center',padding:40,color:'var(--text3)'}}><div style={{fontSize:48,opacity:.3,marginBottom:12}}>📨</div>Henüz kampanya yok.</div>}
          <div style={{display:'flex',flexDirection:'column',gap:12}}>
            {campaigns.map(c=>(
              <div key={c.id} style={{background:'var(--surface)',border:'1px solid var(--border3)',borderRadius:'var(--radius)',padding:18}}>
                <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:12,flexWrap:'wrap',marginBottom:14}}>
                  <div>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                      <span style={{fontSize:16,fontWeight:700}}>{c.name}</span>
                      <Badge color={statusColor[c.status]||'gray'}>{statusLabel[c.status]||c.status}</Badge>
                    </div>
                    <div style={{fontSize:12,color:'var(--text3)'}}>📝 {c.template_name} · 📋 {c.list_name} · {c.total_count} alıcı</div>
                    <div style={{fontSize:12,color:'var(--text3)',marginTop:2}}>Konu: {c.subject}</div>
                  </div>
                  <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                    {c.status==='draft'&&<button className="btn btn-primary btn-sm" onClick={()=>sendCampaign(c)}>▶️ Gönder</button>}
                    {c.status==='sending'&&<button className="btn btn-ghost btn-sm" onClick={()=>{setShowLogs(c);loadLogs(c.id);}}>📊 İzle</button>}
                    {(c.status==='sent'||c.status==='failed')&&<button className="btn btn-ghost btn-sm" onClick={()=>{setShowLogs(c);loadLogs(c.id);}}>📊 Rapor</button>}
                    <button className="btn btn-danger btn-sm" onClick={()=>deleteCampaign(c)}>🗑️</button>
                  </div>
                </div>

                {/* Progress */}
                {(c.status==='sending'||c.status==='sent')&&(
                  <div>
                    <div style={{display:'flex',justifyContent:'space-between',fontSize:12,color:'var(--text3)',marginBottom:4}}>
                      <span>✅ {c.sent_count} gönderildi · ❌ {c.failed_count} başarısız</span>
                      <span>{c.total_count > 0 ? Math.round(((c.sent_count+c.failed_count)/c.total_count)*100) : 0}%</span>
                    </div>
                    <div style={{height:6,background:'var(--surface2)',borderRadius:4}}>
                      <div style={{height:6,background:'var(--accent)',borderRadius:4,width:`${c.total_count>0?Math.round(((c.sent_count+c.failed_count)/c.total_count)*100):0}%`,transition:'width .3s'}}/>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── LİSTELER ── */}
      {tab==='lists'&&(
        <div>
          <div style={{display:'flex',justifyContent:'flex-end',marginBottom:14}}>
            <button className="btn btn-primary btn-sm" onClick={()=>setShowListForm(true)}>+ Liste Oluştur</button>
          </div>
          {!lists.length&&<div style={{textAlign:'center',padding:40,color:'var(--text3)'}}><div style={{fontSize:48,opacity:.3,marginBottom:12}}>📋</div>Henüz liste yok.</div>}
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:12}}>
            {lists.map(l=>(
              <div key={l.id} style={{background:'var(--surface)',border:'1px solid var(--border3)',borderRadius:'var(--radius)',padding:16}}>
                <div style={{fontSize:15,fontWeight:700,marginBottom:4}}>{l.name}</div>
                {l.description&&<div style={{fontSize:12,color:'var(--text3)',marginBottom:8}}>{l.description}</div>}
                <div style={{display:'flex',gap:12,fontSize:13,marginBottom:12}}>
                  <span style={{color:'var(--accent)',fontWeight:700}}>{l.active_count||0} aktif</span>
                  <span style={{color:'var(--text3)'}}>{l.contact_count||0} toplam</span>
                </div>
                <div style={{display:'flex',gap:6}}>
                  <button className="btn btn-ghost btn-sm" style={{flex:1,justifyContent:'center'}} onClick={()=>{setShowContacts(l);loadContacts(l.id);}}>👥 Kontaklar</button>
                  <button className="btn btn-danger btn-sm" onClick={()=>deleteList(l)}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── ŞABLONLAR ── */}
      {tab==='templates'&&(
        <div>
          <div style={{display:'flex',justifyContent:'flex-end',marginBottom:14}}>
            <button className="btn btn-primary btn-sm" onClick={()=>{setEditTemplate(null);setTplForm({name:'',subject:'',body_html:'',body_text:''});setShowTemplateForm(true);}}>+ Şablon Oluştur</button>
          </div>
          {!templates.length&&<div style={{textAlign:'center',padding:40,color:'var(--text3)'}}><div style={{fontSize:48,opacity:.3,marginBottom:12}}>📝</div>Henüz şablon yok.</div>}
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {templates.map(t=>(
              <div key={t.id} style={{background:'var(--surface)',border:'1px solid var(--border3)',borderRadius:'var(--radius)',padding:'12px 16px',display:'flex',alignItems:'center',gap:12}}>
                <div style={{flex:1}}>
                  <div style={{fontSize:14,fontWeight:700}}>{t.name}</div>
                  <div style={{fontSize:12,color:'var(--text3)'}}>Konu: {t.subject} · {timeAgo(t.updated_at)}</div>
                </div>
                <div style={{display:'flex',gap:6}}>
                  <button className="btn btn-ghost btn-sm" onClick={()=>openEditTemplate(t)}>✏️ Düzenle</button>
                  <button className="btn btn-danger btn-sm" onClick={()=>deleteTemplate(t)}>🗑️</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── KAMPANYA OLUŞTUR MODAL ── */}
      {showCampForm&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowCampForm(false)}>
          <div className="modal" style={{maxWidth:480}}>
            <h3>📨 Yeni Kampanya</h3>
            <form onSubmit={createCampaign}>
              <div className="input-group"><label>Kampanya Adı</label><input {...inp} value={campForm.name} onChange={e=>setCampForm(p=>({...p,name:e.target.value}))} placeholder="Temmuz Bülteni" required/></div>
              <div className="input-group"><label>Şablon</label>
                <select className="input" style={{fontSize:13}} value={campForm.template_id} onChange={e=>setCampForm(p=>({...p,template_id:e.target.value}))} required>
                  <option value="">Şablon seç...</option>
                  {templates.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}
                </select>
              </div>
              <div className="input-group"><label>Alıcı Listesi</label>
                <select className="input" style={{fontSize:13}} value={campForm.list_id} onChange={e=>setCampForm(p=>({...p,list_id:e.target.value}))} required>
                  <option value="">Liste seç...</option>
                  {lists.map(l=><option key={l.id} value={l.id}>{l.name} ({l.active_count||0} aktif)</option>)}
                </select>
              </div>
              <div className="input-group"><label>Mail Konusu</label><input {...inp} value={campForm.subject} onChange={e=>setCampForm(p=>({...p,subject:e.target.value}))} placeholder="Merhaba {{name}}!" required/></div>
              <div style={{fontSize:11,color:'var(--text3)',marginTop:-8,marginBottom:12}}>Değişkenler: {'{{name}}'} {'{{email}}'}</div>
              <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
                <button type="button" className="btn btn-ghost" onClick={()=>setShowCampForm(false)}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>{loading?'⏳...':'Oluştur'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── LİSTE OLUŞTUR MODAL ── */}
      {showListForm&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowListForm(false)}>
          <div className="modal" style={{maxWidth:400}}>
            <h3>📋 Yeni Liste</h3>
            <form onSubmit={createList}>
              <div className="input-group"><label>Liste Adı</label><input {...inp} value={listForm.name} onChange={e=>setListForm(p=>({...p,name:e.target.value}))} placeholder="Müşteriler" required/></div>
              <div className="input-group"><label>Açıklama</label><input {...inp} value={listForm.description} onChange={e=>setListForm(p=>({...p,description:e.target.value}))} placeholder="Opsiyonel"/></div>
              <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
                <button type="button" className="btn btn-ghost" onClick={()=>setShowListForm(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">Oluştur</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── KONTAKLAR MODAL ── */}
      {showContacts&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowContacts(null)}>
          <div className="modal" style={{maxWidth:600}}>
            <h3>👥 {showContacts.name} — Kontaklar ({contactTotal})</h3>

            <div style={{display:'flex',gap:8,marginBottom:14}}>
              <form onSubmit={addContact} style={{display:'flex',gap:8,flex:1}}>
                <input {...inp} value={newContact.email} onChange={e=>setNewContact(p=>({...p,email:e.target.value}))} placeholder="email@example.com" type="email" required style={{flex:1,fontSize:13}}/>
                <input {...inp} value={newContact.name} onChange={e=>setNewContact(p=>({...p,name:e.target.value}))} placeholder="Ad (opsiyonel)" style={{width:140,fontSize:13}}/>
                <button type="submit" className="btn btn-primary btn-sm">Ekle</button>
              </form>
              <button className="btn btn-ghost btn-sm" onClick={()=>fileInputRef.current.click()}>📥 CSV</button>
              <input ref={fileInputRef} type="file" accept=".csv" style={{display:'none'}} onChange={importCSV}/>
            </div>

            <div style={{fontSize:11,color:'var(--text3)',marginBottom:10}}>CSV formatı: email, name (başlık satırı gerekli)</div>

            <div style={{maxHeight:300,overflowY:'auto',border:'1px solid var(--border3)',borderRadius:8}}>
              {contacts.length===0&&<div style={{textAlign:'center',padding:20,color:'var(--text3)',fontSize:13}}>Kontak yok</div>}
              {contacts.map(c=>(
                <div key={c.id} style={{display:'flex',alignItems:'center',padding:'8px 12px',borderBottom:'1px solid var(--border3)'}}>
                  <div style={{flex:1}}>
                    <span style={{fontSize:13,fontWeight:600}}>{c.email}</span>
                    {c.name&&<span style={{fontSize:12,color:'var(--text3)',marginLeft:8}}>{c.name}</span>}
                    {c.is_unsubscribed&&<span style={{fontSize:11,color:'#ef4444',marginLeft:8}}>Abonelikten çıktı</span>}
                  </div>
                  <button className="btn btn-danger btn-sm" style={{fontSize:10,padding:'2px 8px'}} onClick={()=>deleteContact(showContacts.id,c.id)}>✕</button>
                </div>
              ))}
            </div>
            <div style={{display:'flex',justifyContent:'flex-end',marginTop:14}}>
              <button className="btn btn-ghost" onClick={()=>setShowContacts(null)}>Kapat</button>
            </div>
          </div>
        </div>
      )}

      {/* ── ŞABLON MODAL ── */}
      {showTemplateForm&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowTemplateForm(false)}>
          <div className="modal" style={{maxWidth:700}}>
            <h3>{editTemplate?'✏️ Şablon Düzenle':'📝 Yeni Şablon'}</h3>
            <form onSubmit={saveTemplate}>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                <div className="input-group"><label>Şablon Adı</label><input {...inp} value={tplForm.name} onChange={e=>setTplForm(p=>({...p,name:e.target.value}))} placeholder="Hoş Geldin Maili" required/></div>
                <div className="input-group"><label>Konu</label><input {...inp} value={tplForm.subject} onChange={e=>setTplForm(p=>({...p,subject:e.target.value}))} placeholder="Merhaba {{name}}!" required/></div>
              </div>
              <div className="input-group">
                <label>HTML İçerik <span style={{fontSize:11,color:'var(--text3)',fontWeight:'normal'}}>Değişkenler: {'{{name}}'} {'{{email}}'}</span></label>
                <textarea className="input" value={tplForm.body_html} onChange={e=>setTplForm(p=>({...p,body_html:e.target.value}))} style={{minHeight:200,fontSize:12,fontFamily:'monospace'}} placeholder="<h1>Merhaba {{name}}!</h1>&#10;<p>İçerik...</p>" required/>
              </div>
              <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
                <button type="button" className="btn btn-ghost" onClick={()=>{setShowTemplateForm(false);setEditTemplate(null);}}>İptal</button>
                <button type="submit" className="btn btn-primary" disabled={loading}>{loading?'⏳...':editTemplate?'💾 Kaydet':'Oluştur'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── LOG/RAPOR MODAL ── */}
      {showLogs&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowLogs(null)}>
          <div className="modal" style={{maxWidth:620}}>
            <h3>📊 {showLogs.name} — Gönderim Raporu</h3>
            <div style={{display:'flex',gap:10,marginBottom:14}}>
              {logStats.map(s=>(
                <div key={s.status} style={{flex:1,textAlign:'center',background:'var(--surface2)',borderRadius:8,padding:'10px 4px'}}>
                  <div style={{fontSize:22,fontWeight:800,color:s.status==='sent'?'#4ade80':s.status==='failed'?'#ef4444':'var(--text3)'}}>{s.count}</div>
                  <div style={{fontSize:11,color:'var(--text3)'}}>{s.status==='sent'?'✅ Gönderildi':s.status==='failed'?'❌ Başarısız':'⏳ Bekliyor'}</div>
                </div>
              ))}
            </div>
            <div style={{maxHeight:350,overflowY:'auto',border:'1px solid var(--border3)',borderRadius:8}}>
              {logs.map((l,i)=>(
                <div key={i} style={{display:'flex',alignItems:'center',padding:'8px 12px',borderBottom:'1px solid var(--border3)',gap:10}}>
                  <span style={{fontSize:13}}>{l.status==='sent'?'✅':'❌'}</span>
                  <div style={{flex:1}}>
                    <span style={{fontSize:13,fontWeight:600}}>{l.email}</span>
                    {l.name&&<span style={{fontSize:12,color:'var(--text3)',marginLeft:8}}>{l.name}</span>}
                    {l.error_msg&&<div style={{fontSize:11,color:'#ef4444'}}>{l.error_msg}</div>}
                  </div>
                  <span style={{fontSize:11,color:'var(--text3)'}}>{timeAgo(l.sent_at)}</span>
                </div>
              ))}
              {!logs.length&&<div style={{textAlign:'center',padding:20,color:'var(--text3)'}}>Log yok</div>}
            </div>
            <div style={{display:'flex',gap:8,justifyContent:'space-between',marginTop:14}}>
              <button className="btn btn-ghost btn-sm" onClick={()=>loadLogs(showLogs.id)}>🔄 Yenile</button>
              <button className="btn btn-ghost" onClick={()=>setShowLogs(null)}>Kapat</button>
            </div>
          </div>
        </div>
      )}

      {/* ── SMTP AYARLARI MODAL ── */}
      {showSettings&&(
        <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&setShowSettings(false)}>
          <div className="modal" style={{maxWidth:500}}>
            <h3>⚙️ SMTP Ayarları</h3>
            <form onSubmit={saveSettings}>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
                <div className="input-group"><label>SMTP Host</label><input {...inp} value={settings.smtp_host||''} onChange={e=>setSettings(p=>({...p,smtp_host:e.target.value}))} placeholder="smtpdm.aliyun.com"/></div>
                <div className="input-group"><label>Port</label><input {...inp} type="number" value={settings.smtp_port||465} onChange={e=>setSettings(p=>({...p,smtp_port:parseInt(e.target.value)}))}/></div>
                <div className="input-group"><label>Kullanıcı (Sender Email)</label><input {...inp} value={settings.smtp_user||''} onChange={e=>setSettings(p=>({...p,smtp_user:e.target.value}))} placeholder="info@domain.com"/></div>
                <div className="input-group"><label>SMTP Şifresi</label><input {...inp} type="password" value={settings.smtp_pass||''} onChange={e=>setSettings(p=>({...p,smtp_pass:e.target.value}))}/></div>
                <div className="input-group"><label>Gönderen Ad</label><input {...inp} value={settings.from_name||''} onChange={e=>setSettings(p=>({...p,from_name:e.target.value}))} placeholder="Şirket Adı"/></div>
                <div className="input-group"><label>Gönderen Email</label><input {...inp} value={settings.from_email||''} onChange={e=>setSettings(p=>({...p,from_email:e.target.value}))} placeholder="info@domain.com"/></div>
              </div>
              <div className="input-group" style={{marginBottom:0}}>
                <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontWeight:'normal'}}>
                  <input type="checkbox" checked={settings.smtp_secure||false} onChange={e=>setSettings(p=>({...p,smtp_secure:e.target.checked}))}/>
                  SSL/TLS (Port 465 için açık olmalı)
                </label>
              </div>
              <div style={{borderTop:'1px solid var(--border3)',paddingTop:14,marginTop:14}}>
                <div style={{fontSize:12,fontWeight:700,color:'var(--text3)',marginBottom:10}}>🧪 SMTP Test</div>
                <div style={{display:'flex',gap:8}}>
                  <input {...inp} value={testEmail} onChange={e=>setTestEmail(e.target.value)} placeholder="test@example.com" style={{flex:1,fontSize:13}}/>
                  <button type="button" className="btn btn-teal btn-sm" onClick={testSMTP} disabled={loading}>{loading?'⏳...':'Test Et'}</button>
                </div>
              </div>
              <div style={{display:'flex',gap:8,justifyContent:'flex-end',marginTop:16}}>
                <button type="button" className="btn btn-ghost" onClick={()=>setShowSettings(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">💾 Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
